import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import { notFoundErrorRemove } from '../../actions';
import { Warning } from '@material-ui/icons';

class LedmoduleNotFound extends React.Component {
    constructor(props) {
        super(props)

        this.handleCloseNotFound = this.handleCloseNotFound.bind(this);
    }

    handleCloseNotFound() {
        this.props.notFoundErrorRemove();
    }

    render() {
        return (
            // <Container className="container-ledmodule-notfound">
            //     <div className="div-text-404">
            //         <p className="title-text-404">
            //             {'Oops... 404!'}
            //         </p>
            //         <p className="message-text-404">
            //             We are sorry that we can not offer you the page you were looking for.
            //             <br />
            //             You may have followed a broken external link or entered a URL incorrectly.
            //             <br />
            //             Or you may have discovered one of the dead ends that our system poses.
            //             <br />
            //             <Link to={`/`} className="a-notfound">
            //                 Here
            //             </Link>
            //             {' you get back to the homepage.'}
            //             <br />
            //             {'By the way: We always like to learn. Tell us what you are looking for: '}
            //             <a href='https://www.osram.com/apps/cbcontact/contacts/add' className="a-notfound">
            //                 Contact us.
            //             </a>
            //         </p>

            //     </div>
            // </Container>
            <Modal show={true} onHide={this.handleCloseNotFound} animation={false}>
                <Modal.Header closeButton style={{ backgroundColor: "#EA4335", color: "white" }}>
                    <Warning style={{ margin: "auto 0" }} />
                    <strong className="mr-auto" style={{ paddingLeft: "0.5rem" }}>{this.props.notFound.data.title}</strong>
                </Modal.Header>

                <Modal.Body>
                    We are sorry but that URL: '{this.props.notFound.config.url}' is not available.
                         <br />
                    You may have followed a broken external link or entered a URL incorrectly, or you may have discovered one of the dead ends that our system poses.
                         <br />
                    <Link to={`/`} className="a-notfound">
                        Here
                    </Link>
                    {' you get back to the homepage.'}
                    {/* <br />
                    {'By the way: We always like to learn. Tell us what you are looking for: '}
                    <a href='https://www.osram.com/apps/cbcontact/contacts/add' className="a-notfound">
                        Contact us.
                    </a> */}
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={this.handleCloseNotFound}>Ok</Button>
                </Modal.Footer>
            </Modal>
        );
    }
};

const mapStateToProps = (state) => {
    return {
        //errors: state.errorsHandler.errors
        notFound: state.errorsHandler.notFound
    };
};

const mapDispatchToProps = {
    notFoundErrorRemove
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LedmoduleNotFound);